import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=466addba&scoped=true&"
import script from "./AppMain.vue?vue&type=script&lang=js&"
export * from "./AppMain.vue?vue&type=script&lang=js&"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=466addba&prod&scoped=true&lang=css&"
import style1 from "./AppMain.vue?vue&type=style&index=1&id=466addba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466addba",
  null
  
)

export default component.exports